import { render, staticRenderFns } from "./PageRoot.vue?vue&type=template&id=2415a38e&"
import script from "./PageRoot.vue?vue&type=script&lang=js&"
export * from "./PageRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports